import { render } from "./MkSalads.vue?vue&type=template&id=25e808d4&scoped=true"
import script from "./MkSalads.vue?vue&type=script&lang=js"
export * from "./MkSalads.vue?vue&type=script&lang=js"

import "./MkSalads.vue?vue&type=style&index=0&id=25e808d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25e808d4"]])

export default __exports__